<template>
  <BaseAlert
    :text="
      $t(
        'register.loyalty_points',
        {
          customer: selectedCustomer?.fullName,
          amount: loyaltyPointsRemaining
        },
        loyaltyPointsRemaining
      )
    "
    mb
    color="success"
  />
</template>
<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRegisterOrderStore } from '@/modules/register/stores/order';

const { order } = useRegisterOrderStore();
const { selectedCustomer } = storeToRefs(useRegisterOrderStore());
const loyaltyPointsRemaining = computed(
  () =>
    (selectedCustomer.value?.loyaltyPoints || 0) -
    order.items.reduce(
      (acc, item) =>
        acc + (item.loyaltyPointsAmount ? item.loyaltyPointsAmount : 0),
      0,
    ),
);
</script>
